import React, { useEffect } from 'react';
import Select from '../Select';
import useOrganizationOptions, {
  OPERATOR_ORG_ID,
} from 'hooks/useOrganizationOptions';

interface Props {
  permission: string;
  value?: number | null;
  onChange: (organizationId: number) => void;
}

// 조직 선택 드롭다운. permission 을 받아 접근 가능 조직만 보여준다.
// - 옵션 1개: 자동 선택 후 UI 숨김
// - 옵션 0개: 안내 문구 노출 (이 경우 조직 생성 권한 자체가 없는 어드민)
// - 운영 조직 role: 전체 조직, 미선택 시 운영 조직 기본
function OrganizationSelect({ permission, value, onChange }: Props) {
  const { options, single, isGlobal } = useOrganizationOptions(permission);

  useEffect(() => {
    if (single !== null && value !== single) {
      onChange(single);
    } else if (isGlobal && value == null) {
      onChange(OPERATOR_ORG_ID);
    }
  }, [single, isGlobal, value, onChange]);

  if (isGlobal && options.length === 0) return null;

  if (options.length === 0) {
    return (
      <p css={{ color: '#d14343', fontSize: 13 }}>
        접근 가능한 조직이 없습니다
      </p>
    );
  }

  if (!isGlobal && options.length === 1) return null;

  return (
    <Select<string>
      options={options.map((o) => ({ name: o.name, value: String(o.value) }))}
      value={value != null ? String(value) : ''}
      defaultTitle="조직 선택"
      handleChange={(v) => onChange(Number(v))}
    />
  );
}

export default OrganizationSelect;
